import trans from "../utils";

export const RegularMainData = [
  {
    id: 1,
    name: "Oil Change",
    code: "#125125",
    priority: "Highest",
    intervals: "Every 200 KM Or 1 Day(s)",
    description: "Description for the category",
    vehicle: 6,
  },
  {
    id: 2,
    name: "Battery Performance",
    code: "#125125",
    priority: "Low",
    intervals: "Every 200 KM Or 1 Day(s)",
    description: "TEST REGULAR MAINTENANCE",
    vehicle: 5,
  },
  {
    id: 3,
    name: "Brake Check",
    code: "#456789",
    priority: "Medium",
    intervals: "Every 300 KM Or 2 Day(s)",
    description: "Ensure the brakes are working efficiently",
    vehicle: 4,
  },
  {
    id: 4,
    name: "Tire Alignment",
    code: "#987654",
    priority: "High",
    intervals: "Every 500 KM Or 5 Day(s)",
    description: "Adjust alignment for smooth driving",
    vehicle: 39,
  },
  {
    id: 5,
    name: "Coolant Refill",
    code: "#567890",
    priority: "Low",
    intervals: "Every 600 KM Or 10 Day(s)",
    description: "Check and refill engine coolant",
  },
  {
    id: 6,
    name: "Air Filter Replacement",
    code: "#234567",
    priority: "High",
    intervals: "Every 700 KM Or 7 Day(s)",
    description: "Replace air filters to improve engine performance",
  },
  {
    id: 7,
    name: "Spark Plug Inspection",
    code: "#876543",
    priority: "Highest",
    intervals: "Every 150 KM Or 3 Day(s)",
    description: "Inspect spark plugs for wear and tear",
  },
  {
    id: 8,
    name: "Engine Inspection",
    code: "#112233",
    priority: "Medium",
    intervals: "Every 1000 KM Or 15 Day(s)",
    description: "Thoroughly check engine condition",
  },
  {
    id: 9,
    name: "Battery Health Check",
    code: "#445566",
    priority: "Low",
    intervals: "Every 400 KM Or 8 Day(s)",
    description: "Ensure the battery is in optimal condition",
  },
  {
    id: 10,
    name: "Transmission Fluid",
    code: "#778899",
    priority: "High",
    intervals: "Every 800 KM Or 12 Day(s)",
    description: "Inspect and refill transmission fluid",
  },
  {
    id: 11,
    name: "Fuel System Inspection",
    code: "#998877",
    priority: "Medium",
    intervals: "Every 1200 KM Or 20 Day(s)",
    description: "Check for clogs or leaks in the fuel system",
  },
  {
    id: 12,
    name: "Steering System Check",
    code: "#334455",
    priority: "Highest",
    intervals: "Every 500 KM Or 5 Day(s)",
    description: "Ensure smooth steering operation",
  },
  {
    id: 13,
    name: "Exhaust System Check",
    code: "#667788",
    priority: "Medium",
    intervals: "Every 700 KM Or 10 Day(s)",
    description: "Inspect for leaks and emissions compliance",
  },
  {
    id: 14,
    name: "Suspension Check",
    code: "#556677",
    priority: "Low",
    intervals: "Every 900 KM Or 15 Day(s)",
    description: "Ensure suspension components are in good condition",
  },
  {
    id: 15,
    name: "Wiper Blade Replacement",
    code: "#443322",
    priority: "Low",
    intervals: "Every 200 KM Or 5 Day(s)",
    description: "Replace worn-out wiper blades",
  },
  {
    id: 16,
    name: "Headlight Check",
    code: "#221100",
    priority: "High",
    intervals: "Every 300 KM Or 3 Day(s)",
    description: "Ensure headlights are functioning properly",
  },
  {
    id: 17,
    name: "Brake Fluid Refill",
    code: "#778800",
    priority: "Highest",
    intervals: "Every 250 KM Or 4 Day(s)",
    description: "Refill and check brake fluid levels",
  },
  {
    id: 18,
    name: "Clutch Inspection",
    code: "#339988",
    priority: "Medium",
    intervals: "Every 600 KM Or 10 Day(s)",
    description: "Inspect the clutch for smooth operation",
  },
  {
    id: 19,
    name: "Radiator Cleaning",
    code: "#559900",
    priority: "High",
    intervals: "Every 1000 KM Or 20 Day(s)",
    description: "Clean the radiator for optimal cooling",
  },
  {
    id: 20,
    name: "Drive Belt Inspection",
    code: "#779922",
    priority: "Highest",
    intervals: "Every 400 KM Or 8 Day(s)",
    description: "Check drive belt for wear or damage",
  },
  {
    id: 21,
    name: "Engine Oil Check",
    code: "#449955",
    priority: "High",
    intervals: "Every 250 KM Or 5 Day(s)",
    description: "Check and top up engine oil levels",
  },
];

export const OldEvents = [
  {
    start: new Date(2024, 10, 18, 13, 0), // Start date and time
    end: new Date(2024, 10, 20, 15, 0), // End date and time
    data: {
      appointment: {
        id: 1,
        status: "done",
        title: "Workshop test 01",
        resource: "Dr Alex",
        address: "Workshop test 01",
        type: "Emergency Maintenance",
        description:
          "Support Your Points with Data, we value evidence-based insights. During our Support Your Points with Data: , we value evidence-based insights. During our Support Your Points with Data: , we value evidence-b",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2024, 10, 18, 13, 0), // Start date and time
    end: new Date(2024, 10, 20, 15, 0), // End date and time
    data: {
      appointment: {
        id: 1,
        status: "done",
        title: "Workshop test 01",
        resource: "Dr Alex",
        address: "Workshop test 01",
        type: "Emergency Maintenance",
        description:
          "Support Your Points with Data, we value evidence-based insights. During our Support Your Points with Data: , we value evidence-based insights. During our Support Your Points with Data: , we value evidence-b",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2024, 10, 18, 13, 0), // Start date and time
    end: new Date(2024, 10, 20, 15, 0), // End date and time
    data: {
      appointment: {
        id: 1,
        status: "done",
        title: "Workshop test 01",
        resource: "Dr Alex",
        address: "Workshop test 01",
        type: "Emergency Maintenance",
        description:
          "Support Your Points with Data, we value evidence-based insights. During our Support Your Points with Data: , we value evidence-based insights. During our Support Your Points with Data: , we value evidence-b",
      },
    },
    resourceId: 1,
  },

  {
    start: new Date(2024, 10, 18, 10, 0), // Start date and time
    end: new Date(2024, 10, 18, 12, 0), // End date and time
    data: {
      appointment: {
        id: 1,
        status: "upcoming",
        title: "Workshop test 01",
        resource: "Dr Alex",
        address: "Workshop test 01",
        type: "Emergency Maintenance",
        description:
          "Support Your Points with Data, we value evidence-based insights. During our Support Your Points with Data: , we value evidence-based insights. During our Support Your Points with Data: , we value evidence-b",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2024, 10, 18, 2, 0), // Start date and time
    end: new Date(2024, 10, 18, 3, 0), // End date and time
    data: {
      appointment: {
        id: 1,
        status: "done",
        title: "Workshop test 01",
        resource: "Dr Alex",
        address: "Workshop test 01",
        type: "Emergency Maintenance",
        description:
          "Support Your Points with Data, we value evidence-based insights. During our Support Your Points with Data: , we value evidence-based insights. During our Support Your Points with Data: , we value evidence-b",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2024, 10, 21, 10, 0), // Start date and time
    end: new Date(2024, 10, 21, 12, 0), // End date and time
    data: {
      appointment: {
        id: 1,
        status: "urgent",
        title: "Workshop test 01",
        resource: "Dr Alex",
        address: "Workshop test 01",
        type: "Emergency Maintenance",
        description:
          "Support Your Points with Data, we value evidence-based insights. During our Support Your Points with Data: , we value evidence-based insights. During our Support Your Points with Data: , we value evidence-b",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2024, 10, 22, 10, 0), // Start date and time
    end: new Date(2024, 10, 22, 12, 0), // End date and time
    data: {
      appointment: {
        id: 1,
        status: "upcoming",
        title: "Workshop test 01",
        resource: "Dr Alex",
        address: "Workshop test 01",
        type: "Emergency Maintenance",
        description:
          "Support Your Points with Data, we value evidence-based insights. During our Support Your Points with Data: , we value evidence-based insights. During our Support Your Points with Data: , we value evidence-b",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2024, 10, 21, 13, 0), // Start date and time
    end: new Date(2024, 10, 21, 15, 0), // End date and time
    data: {
      appointment: {
        id: 1,
        status: "pending",
        title: "Workshop test 02",
        resource: "Dr Hamed",
        address: "Workshop test 01",
        type: "Emergency Maintenance",
        description:
          "Support Your Points with Data, we value evidence-based insights. During our Support Your Points with Data: , we value evidence-based insights. During our Support Your Points with Data: , we value evidence-b",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2024, 10, 21, 13, 0), // Start date and time
    end: new Date(2024, 10, 21, 15, 0), // End date and time
    data: {
      appointment: {
        id: 1,
        status: "urgent",
        title: "Workshop test 02",
        resource: "Dr Hamed",
        address: "Workshop test 01",
        type: "Emergency Maintenance",
        description:
          "Support Your Points with Data, we value evidence-based insights. During our Support Your Points with Data: , we value evidence-based insights. During our Support Your Points with Data: , we value evidence-b",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2024, 10, 20, 10, 0), // Start date and time
    end: new Date(2024, 10, 20, 12, 0), // End date and time
    data: {
      blockout: {
        id: 1,
        name: "independence day",
      },
    },
    resourceId: 2,
  },
  {
    start: new Date(2024, 11, 18, 13, 0), // Start date and time
    end: new Date(2024, 11, 21, 15, 0), // End date and time
    data: {
      appointment: {
        id: 1,
        status: "upcoming",
        title: "Workshop test 02",
        resource: "Dr Hamed",
        address: "Workshop test 01",
        type: "Emergency Maintenance",
        description:
          "Support Your Points with Data, we value evidence-based insights. During our Support Your Points with Data: , we value evidence-based insights. During our Support Your Points with Data: , we value evidence-b",
      },
    },
    resourceId: 1,
  },
];

export const events = [
  {
    start: new Date(2025, 0, 3, 10, 0),
    end: new Date(2025, 0, 3, 14, 0),
    data: {
      appointment: {
        id: 1,
        status: "pending",
        title: "Workshop test 01",
        resource: "Engineer Bob",
        address: "Workshop location 01",
        type: "Inspection",
        description: "This is a test description for event 1 in January 2025.",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2025, 0, 3, 10, 0),
    end: new Date(2025, 0, 3, 14, 0),
    data: {
      appointment: {
        id: 1,
        status: "upcoming",
        title: "Workshop test 01",
        resource: "Engineer Bob",
        address: "Workshop location 01",
        type: "Inspection",
        description: "This is a test description for event 1 in January 2025.",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2025, 0, 3, 10, 0),
    end: new Date(2025, 0, 3, 14, 0),
    data: {
      appointment: {
        id: 1,
        status: "done",
        title: "Workshop test 01",
        resource: "Engineer Bob",
        address: "Workshop location 01",
        type: "Inspection",
        description: "This is a test description for event 1 in January 2025.",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2025, 0, 3, 10, 0),
    end: new Date(2025, 0, 3, 14, 0),
    data: {
      appointment: {
        id: 1,
        status: "urgent",
        title: "Workshop test 01",
        resource: "Engineer Bob",
        address: "Workshop location 01",
        type: "Inspection",
        description: "This is a test description for event 1 in January 2025.",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2025, 0, 3, 10, 0),
    end: new Date(2025, 0, 3, 14, 0),
    data: {
      appointment: {
        id: 1,
        status: "pending",
        title: "Workshop test 01",
        resource: "Engineer Bob",
        address: "Workshop location 01",
        type: "Inspection",
        description: "This is a test description for event 1 in January 2025.",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2025, 0, 3, 10, 0),
    end: new Date(2025, 0, 3, 14, 0),
    data: {
      appointment: {
        id: 1,
        status: "pending",
        title: "Workshop test 01",
        resource: "Engineer Bob",
        address: "Workshop location 01",
        type: "Inspection",
        description: "This is a test description for event 1 in January 2025.",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2025, 0, 3, 10, 0),
    end: new Date(2025, 0, 3, 14, 0),
    data: {
      appointment: {
        id: 1,
        status: "urgent",
        title: "Workshop test 01",
        resource: "Engineer Bob",
        address: "Workshop location 01",
        type: "Inspection",
        description: "This is a test description for event 1 in January 2025.",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2025, 0, 3, 10, 0),
    end: new Date(2025, 0, 3, 14, 0),
    data: {
      appointment: {
        id: 1,
        status: "done",
        title: "Workshop test 01",
        resource: "Engineer Bob",
        address: "Workshop location 01",
        type: "Inspection",
        description: "This is a test description for event 1 in January 2025.",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2025, 0, 5, 9, 30),
    end: new Date(2025, 0, 5, 13, 30),
    data: {
      appointment: {
        id: 2,
        status: "done",
        title: "Workshop test 02",
        resource: "Technician Sam",
        address: "Workshop location 02",
        type: "Emergency Maintenance",
        description: "This is a test description for event 2 in January 2025.",
      },
    },
    resourceId: 2,
  },
  {
    start: new Date(2025, 0, 8, 11, 0),
    end: new Date(2025, 0, 8, 16, 0),
    data: {
      appointment: {
        id: 3,
        status: "in-progress",
        title: "Workshop test 03",
        resource: "Dr Alex",
        address: "Workshop location 03",
        type: "Scheduled Maintenance",
        description: "This is a test description for event 3 in January 2025.",
      },
    },
    resourceId: 3,
  },
  {
    start: new Date(2025, 0, 10, 8, 30),
    end: new Date(2025, 0, 10, 12, 30),
    data: {
      appointment: {
        id: 4,
        status: "pending",
        title: "Workshop test 04",
        resource: "Engineer Bob",
        address: "Workshop location 04",
        type: "Inspection",
        description: "This is a test description for event 4 in January 2025.",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2025, 0, 15, 14, 0),
    end: new Date(2025, 0, 15, 18, 0),
    data: {
      appointment: {
        id: 5,
        status: "done",
        title: "Workshop test 05",
        resource: "Technician Sam",
        address: "Workshop location 05",
        type: "Emergency Maintenance",
        description: "This is a test description for event 5 in January 2025.",
      },
    },
    resourceId: 2,
  },
  {
    start: new Date(2025, 0, 18, 9, 0),
    end: new Date(2025, 0, 18, 13, 0),
    data: {
      appointment: {
        id: 6,
        status: "in-progress",
        title: "Workshop test 06",
        resource: "Dr Alex",
        address: "Workshop location 06",
        type: "Scheduled Maintenance",
        description: "This is a test description for event 6 in January 2025.",
      },
    },
    resourceId: 3,
  },
  {
    start: new Date(2025, 0, 20, 10, 30),
    end: new Date(2025, 0, 20, 12, 30),
    data: {
      appointment: {
        id: 7,
        status: "pending",
        title: "Workshop test 07",
        resource: "Engineer Bob",
        address: "Workshop location 07",
        type: "Inspection",
        description: "This is a test description for event 7 in January 2025.",
      },
    },
    resourceId: 1,
  },
  {
    start: new Date(2025, 0, 22, 8, 0),
    end: new Date(2025, 0, 22, 17, 0),
    data: {
      appointment: {
        id: 8,
        status: "done",
        title: "Workshop test 08",
        resource: "Technician Sam",
        address: "Workshop location 08",
        type: "Emergency Maintenance",
        description: "This is a test description for event 8 in January 2025.",
      },
    },
    resourceId: 2,
  },
  {
    start: new Date(2025, 0, 25, 12, 0),
    end: new Date(2025, 0, 25, 16, 0),
    data: {
      appointment: {
        id: 9,
        status: "in-progress",
        title: "Workshop test 09",
        resource: "Dr Alex",
        address: "Workshop location 09",
        type: "Scheduled Maintenance",
        description: "This is a test description for event 9 in January 2025.",
      },
    },
    resourceId: 3,
  },
  {
    start: new Date(2025, 0, 28, 14, 30),
    end: new Date(2025, 0, 28, 20, 0),
    data: {
      appointment: {
        id: 10,
        status: "pending",
        title: "Workshop test 10",
        resource: "Engineer Bob",
        address: "Workshop location 10",
        type: "Inspection",
        description: "This is a test description for event 10 in January 2025.",
      },
    },
    resourceId: 1,
  },
];
export const dayOptions = [
  { label: trans("Sunday"), value: "Sun" },
  { label: trans("Monday"), value: "Mon" },
  { label: trans("Tuesday"), value: "Tue" },
  { label: trans("Wednesday"), value: "Wed" },
  { label: trans("Thursday"), value: "Thu" },
  { label: trans("Friday"), value: "Fri" },
  { label: trans("Saturday"), value: "Sat" },
];

export const ServiceType = [
  { label: trans("electrical"), value: "electrical" },
  { label: trans("air conditioning"), value: "air_conditioning" },
  { label: trans("kiriazi"), value: "kiriazi" },
];

export const EgyptGovernorates = [
  "Cairo", "Giza", "Alexandria", "Dakahlia", "Sharqia", "Qalyubia", "Gharbia",
  "Beheira", "Kafr el-Sheikh", "Damietta", "Port Said", "Ismailia", "Suez",
  "North Sinai", "South Sinai", "Red Sea", "Faiyum", "Beni Suef", "Minya",
  "Asyut", "Sohag", "Qena", "Luxor", "Aswan", "Matrouh", "New Valley", "Monufia",
].map((name) => ({ label: trans(name), value: name }));

export const requestStatus = [
  { label: "pending", value: "pending" },
  { label: "completed", value: "completed" },
  { label: "inProgress", value: "inProgress" },
  { label: "cancelled", value: "cancelled" },
  { label: "cancelled_request", value: "cancelled_request" },
  { label: "none", value: "none" },
  { label: "Assigned", value: "Assigned" },
];

export const statusColors = {
  inProgress: `blue`,
  pending: `orange`,
  completed: `green`,
  cancelled: `red`,
  cancelled_request: `volcano`,
  none: `default`,
  Assigned: `purple`,
};

export const WorkloadStatusColor = {
  underutilized: `orange`,
  balanced: `green`,
  overloaded: `red`,
  default: `default`,
};

export const PriorityColor = {
  low: `orange`,
  medium: `green`,
  high: `red`,
};

export const TaskReportStatus = [
  { label: "TODO", value: "todo" },
  { label: "In-Progress", value: "inProgress" },
  { label: "Done", value: "done" },
];

export const DeviceAssignmentStatus = [
  { label: "active", value: "active" },
  { label: "inactive", value: "inactive" },
];

export const CountryOptions = [
  {
    label: trans("Africa"),
    options: [
      { label: trans("Egypt"), value: "egypt" },
      // { label: trans("Nigeria"), value: "nigeria" },
      // { label: trans("South Africa"), value: "south-africa" },
      // { label: trans("Kenya"), value: "kenya" },
      // { label: trans("Morocco"), value: "morocco" },
      // { label: trans("Ghana"), value: "ghana" },
      // { label: trans("Algeria"), value: "algeria" },
      // { label: trans("Tunisia"), value: "tunisia" },
    ],
  },
  {
    label: trans("North America"),
    options: [
      { label: trans("Canada"), value: "canada" },
      { label: trans("USA"), value: "usa" },
      { label: trans("Mexico"), value: "mexico" },
    ],
  },
  {
    label: trans("South America"),
    options: [
      { label: trans("Brazil"), value: "brazil" },
      { label: trans("Argentina"), value: "argentina" },
    ],
  },
  {
    label: trans("Europe"),
    options: [
      { label: trans("France"), value: "france" },
      { label: trans("Germany"), value: "germany" },
      { label: trans("Italy"), value: "italy" },
      { label: trans("Spain"), value: "spain" },
      { label: trans("UK"), value: "uk" },
      { label: trans("Belgium"), value: "belgium" },
      { label: trans("Netherlands"), value: "netherlands" },
      { label: trans("Portugal"), value: "portugal" },
      { label: trans("Sweden"), value: "sweden" },
      { label: trans("Russia"), value: "russia" },
    ],
  },
  {
    label: trans("Asia"),
    options: [
      { label: trans("China"), value: "china" },
      { label: trans("India"), value: "india" },
      { label: trans("Japan"), value: "japan" },
      { label: trans("South Korea"), value: "korea-south" },
      { label: trans("Taiwan"), value: "taiwan" },
      { label: trans("Turkey"), value: "turkey" },
      // { label: trans("Indonesia"), value: "indonesia" },
      { label: trans("Saudi Arabia"), value: "saudi-arabia" },
      { label: trans("UAE"), value: "uae" },
      // { label: trans("Pakistan"), value: "pakistan" },
    ],
  },
  {
    label: trans("Oceania"),
    options: [{ label: trans("Australia"), value: "australia" }],
  },
];

export const AreaRoomOptions = [
  { label: trans("Bathroom"), value: "Bathroom" },
  { label: trans("Kitchen"), value: "Kitchen" },
  { label: trans("Living Room"), value: "Living Room" },
  { label: trans("Bedroom"), value: "Bedroom" },
  { label: trans("Dining Room"), value: "Dining Room" },
  { label: trans("Office"), value: "Office" },
  { label: trans("Hallway"), value: "Hallway" },
  { label: trans("Staircase"), value: "Staircase" },
  { label: trans("Balcony"), value: "Balcony" },
  { label: trans("Terrace"), value: "Terrace" },
  { label: trans("Garage"), value: "Garage" },
  { label: trans("Storage"), value: "Storage" },
  { label: trans("Basement"), value: "Basement" },
  { label: trans("Attic"), value: "Attic" },
  { label: trans("Laundry Room"), value: "Laundry Room" },
  { label: trans("Utility Room"), value: "Utility Room" },
  { label: trans("Lobby"), value: "Lobby" },
  { label: trans("Reception"), value: "Reception" },
  { label: trans("Conference Room"), value: "Conference Room" },
  { label: trans("Parking"), value: "Parking" },
  { label: trans("Elevator"), value: "Elevator" },
  { label: trans("Corridor"), value: "Corridor" },
  { label: trans("Mechanical Room"), value: "Mechanical Room" },
  { label: trans("Electrical Room"), value: "Electrical Room" },
  { label: trans("Exterior"), value: "Exterior" },
  { label: trans("Rooftop"), value: "Rooftop" },
  { label: trans("Other"), value: "Other" },
];
